import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/smile-wink': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8c137 0 248 111 248 248s-111 248-248 248-248-111-248-248 111-248 248-248zM248 456c110.3 0 200-89.7 200-200s-89.7-200-200-200-200 89.7-200 200 89.7 200 200 200zM365.8 309.6c10.2 8.5 11.6 23.6 3.1 33.8-30 36-74.1 56.6-120.9 56.6s-90.9-20.6-120.9-56.6c-8.4-10.2-7.1-25.3 3.1-33.8 10.1-8.4 25.3-7.1 33.8 3.1 20.8 25.1 51.5 39.4 84 39.4s63.2-14.4 84-39.4c8.5-10.2 23.6-11.6 33.8-3.1zM168 240c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zM328 180c25.7 0 55.9 16.9 59.7 42.1 1.8 11.1-11.3 18.2-19.8 10.8l-9.5-8.5c-14.8-13.2-46.2-13.2-61 0l-9.5 8.5c-8.3 7.4-21.5 0.4-19.8-10.8 4-25.2 34.2-42.1 59.9-42.1z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/smile-wink.js
// module id = 1814
// module chunks = 0